import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/add.svg'


const _withScopeId = n => (_pushScopeId("data-v-7dfaa366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "edit-team-spacer" }
const _hoisted_2 = { class: "small-text" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "small-text team-prefix m-0" }
const _hoisted_5 = {
  key: 1,
  class: "h1"
}
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_8 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_9 = {
  key: 3,
  class: "animation-spacer"
}
const _hoisted_10 = {
  key: 4,
  class: "team-members-container"
}
const _hoisted_11 = { class: "small-text" }
const _hoisted_12 = { class: "team-members" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_14 = { class: "add-member" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputElement = _resolveComponent("InputElement")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_UserListItem = _resolveComponent("UserListItem")!
  const _component_ButtonElement = _resolveComponent("ButtonElement")!
  const _component_ModalLayout = _resolveComponent("ModalLayout")!

  return (_openBlock(), _createBlock(_component_ModalLayout, {
    "has-close-button": true,
    onOnClose: _ctx.refreshHomePage
  }, {
    footer: _withCtx(() => [
      (_ctx.isEditing && !_ctx.isLive)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ButtonElement, {
              theme: "secondary",
              type: "submit",
              loading: _ctx.loadingDeleteTeam,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doDeleteTeam()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modals.team.buttons.delete')), 1)
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_ButtonElement, {
              theme: "primary",
              type: "submit",
              loading: _ctx.loadingUpdateTeamName,
              disabled: _ctx.isChangeNameButtonDisabled,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doUpdateTeamName()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modals.team.buttons.change_team_name')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.team.is_leader)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-outline-light",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEditing = true))
                }, _toDisplayString(_ctx.$t('modals.team.buttons.edit')), 1))
              : _createCommentVNode("", true),
            (!_ctx.team.is_leader && !_ctx.isLive)
              ? (_openBlock(), _createBlock(_component_ButtonElement, {
                  key: 1,
                  theme: "secondary",
                  type: "button",
                  loading: _ctx.loadingLeaveTeam,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doLeaveTeam()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('modals.team.buttons.leave')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modals.team.team_name')), 1),
        (_ctx.isEditing && !_ctx.isLive)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              class: "team-name-form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.doUpdateTeamName()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('modals.team.team')), 1),
                _createVNode(_component_InputElement, {
                  class: "w-100",
                  errors: _ctx.errorUpdateTeamName,
                  modelValue: _ctx.team.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.team.name) = $event)),
                  placeholder: _ctx.$t('modals.team.team_name_placeholder')
                }, null, 8, ["errors", "modelValue", "placeholder"])
              ])
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "#" + _toDisplayString(_ctx.team.name), 1))
      ]),
      (_ctx.errorDeleteTeam)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorDeleteTeam), 1))
        : _createCommentVNode("", true),
      (_ctx.errorGetTeamStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorGetTeamStatus), 1))
        : _createCommentVNode("", true),
      (_ctx.errorLeaveTeam)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorLeaveTeam), 1))
        : _createCommentVNode("", true),
      (_ctx.loadingGetTeamStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_lottie_animation, {
              class: "loading-animation",
              animationData: require('@/assets/animations/loader.json'),
              loop: true,
              autoPlay: true,
              speed: 1
            }, null, 8, ["animationData"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('modals.team.members')), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_UserListItem, {
                member: _ctx.team.leader,
                isCaptain: true
              }, null, 8, ["member"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.members, (member) => {
                return (_openBlock(), _createBlock(_component_UserListItem, {
                  key: member.user_id,
                  member: member,
                  isEditing: _ctx.isEditing,
                  editErrorKickMember: _ctx.editErrorKickMember,
                  onOnRemove: _ctx.refreshTeam
                }, null, 8, ["member", "isEditing", "editErrorKickMember", "onOnRemove"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.pending_invites, (member) => {
                return (_openBlock(), _createBlock(_component_UserListItem, {
                  key: member.user_id,
                  member: member,
                  isEditing: _ctx.isEditing,
                  editErrorKickMember: _ctx.editErrorKickMember,
                  onOnRemove: _ctx.refreshTeam
                }, null, 8, ["member", "isEditing", "editErrorKickMember", "onOnRemove"]))
              }), 128))
            ]),
            (_ctx.isEditing && !_ctx.hasEnded)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "add-member-container d-flex align-items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSearchUsersModal()))
                }, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('modals.team.add_members')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}